module.exports = __webpack_public_path__ + "static/media/template3.b029d749.png";